<template>
<!--    <div style="width: 100%;height: 100%;">-->

      <!--    播放按钮组件     -->
      <div style="position: relative;top: -95px">
        <!--     <div style="position: relative;top: -95px">-->
        <div  class="div" v-drag
              style="position: relative;left:40%;top:50%;z-index: 998;background-color: #f8f8f9;width: 410px;height: 55px;border-radius:5px;box-shadow:0 2px 12px 0 rgba(0,0,0,.3);">
          <Row>
            <div style="width: 100%;">
              <Slider style="height: 10px;width: 100%;padding-left: 15px;padding-right: 15px;" input-size="small"
                      :disabled="playControl.playing || content.length === 0" v-model="playControl.currentFrameIndex"
                      :max="content.length" @on-change="onSliderChange" highlight-row="true"></Slider>
            </div>
          </Row>
          <Row style="text-align:center">
            <Col span="24">
<!--              <Poptip trigger="hover" content="上一条移动数据">-->
                <Button size="small" type="primary" :disabled="playControl.playing || content.length === 0"
                        style="margin-right: 5px;"
                        @click="prevRunFrame" shape="circle" icon="md-skip-backward"></Button>
<!--              </Poptip>-->
<!--              <Poptip trigger="hover" content="后退">-->
                <Button type="primary" size="small" :disabled="playControl.playing || content.length === 0"
                        style="margin-right: 5px;"
                        @click="prevFrame" shape="circle" icon="md-rewind"></Button>
<!--              </Poptip>-->
<!--              <Poptip trigger="hover" content="播放">-->
                <Button type="primary" size="small" :disabled="playControl.playing || content.length === 0"
                        style="margin-right: 5px;"
                        @click="play" shape="circle" icon="md-play"></Button>
<!--              </Poptip>-->
<!--              <Poptip trigger="hover" content="暂停">-->
                <Button type="primary" size="small" :disabled="!playControl.playing || content.length === 0"
                        style="margin-right: 5px;"
                        @click="pause" shape="circle" icon="md-pause"></Button>
<!--              </Poptip>-->
<!--              <Poptip trigger="hover" content="停止">-->
                <Button type="primary" size="small" :disabled="playControl.playing || content.length === 0"
                        style="margin-right: 5px;"
                        @click="stop" shape="circle" icon="md-square"></Button>
<!--              </Poptip>-->
<!--              <Poptip trigger="hover" content="快进">-->
                <Button type="primary" size="small" :disabled="playControl.playing || content.length === 0"
                        style="margin-right: 5px;"
                        @click="nextFrame" shape="circle" icon="md-fastforward"></Button>
<!--              </Poptip>-->
<!--              <Poptip trigger="hover" content="下一条移动数据">-->
                <Button type="primary" size="small" :disabled="playControl.playing || content.length === 0"
                        style="margin-right: 5px;"
                        @click="nextRunFrame" shape="circle" icon="md-skip-forward"></Button>
<!--              </Poptip>-->
              <Select size="small" placeholder="速度" :disabled="playControl.playing || content.length === 0"
                      style="padding-right: 5px;display: inline-block; width: 80px;" v-model="playControl.playInterval">
                <Option value="2000" key="2000">X1</Option>
                <Option value="1000" key="1000">X2</Option>
                <Option value="500" key="500">X4</Option>
                <Option value="250" key="250">X8</Option>
                <Option value="125" key="125">16</Option>
              </Select>
            </Col>
          </Row>
        </div>
      </div>

<!--    </div>-->
</template>

<script>
  import Vue from 'vue'
  import { GPS } from '@/libs/positonUtils'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { explainAlarmSign, explainState, explainDirection } from '@/libs/jt808util'
    export default {
        name: "play-control",
      data(){
          return{

            content: [],

            pageIndex: 1,

            playControl: {
              playing: false,
              playInterval: 2000,
              playIntervalTimer: null,
              currentFrameIndex: 0,
              currentFrame: null,
              display: {
                locateDatetime: '无',
                state: '无',
                alarmSign: '无',
                speed: '无',
                mileage: '无',
                direction: '无',
                longitude: '无',
                latitude: '无',
                recvDatetime: '无'
              }
            },


          }
      },
      methods:{

        initPlayControl (locateHistorys) {
          this.content = locateHistorys
          this.playControl.currentFrameIndex = 0
          this.playControl.currentFrame = this.content[0]
          this.playControl.playInterval = 2000
        },

        // 更新与格式化轨迹数据
        renderDisplay () {
          let d = new Date(this.playControl.currentFrame.locateDatetimeLongValue)
          this.playControl.display.locateDatetime = d.Format('yyyy年MM月dd日 hh:mm:ss')
          this.playControl.display.state = explainState(this.playControl.currentFrame.state)
          this.playControl.display.alarmSign = explainAlarmSign(this.playControl.currentFrame.alarmSign)
          this.playControl.display.speed = this.playControl.currentFrame.speed / 10
          this.playControl.display.mileage = this.playControl.currentFrame.mileage / 10
          this.playControl.display.direction = explainDirection(this.playControl.currentFrame.direction)
          this.playControl.display.longitude = this.playControl.currentFrame.longitude
          this.playControl.display.latitude = this.playControl.currentFrame.latitude
          this.playControl.display.directionNum = this.playControl.currentFrame.direction
          d = new Date(this.playControl.currentFrame.recvDatetimeLongValue)
          this.playControl.display.recvDatetime = d.Format('yyyy年MM月dd日 hh:mm:ss')
          // console.log(this.playControl.display)
          // this.drawCar(this.playControl.display)
          this.$emit('drawCar',this.playControl.display)
        },
        /**
         * 播放按钮模块
         */
        // 滑块
        onSliderChange (val) {
          // console.log('onSliderChange')
          console.log(val)
          this.playControl.currentFrameIndex = val
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
          // this.$emit('onSliderChange', this.locateHistorys,this.trips)
        },
        // 控制播放进度条
        onRowClick (data, index) {
          if (!this.pageIndex) {
            this.pageIndex = 1
          }
          index = (this.pageIndex - 1) * 30 + index
          console.log('onRowClick:' + index)
          // this.$refs.bigDataTableRef.setHighlightRow(index)
          // this.$refs.bigDataTableRef.scrollToRow(index)
          this.$emit('setHighlightRow', index)
          this.$emit('scrollToRow', index)
          this.playControl.currentFrameIndex = index
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.renderDisplay()
        },
        // 播放
        play () {
          if (this.playControl.playIntervalTimer) {
            clearInterval(this.playControl.playIntervalTimer)
            this.playControl.playIntervalTimer = null
          }
          this.playControl.playIntervalTimer = setInterval(this.onTimer, this.playControl.playInterval)
          this.playControl.playing = true
          this.$Message.success('开始播放')
        },

        pause () {
          if (this.playControl.playIntervalTimer) {
            clearInterval(this.playControl.playIntervalTimer)
            this.playControl.playIntervalTimer = null
          }
          this.playControl.playing = false
        },

        stop () {
          this.$Modal.confirm({
            title: '确定重置播放',
            content: '<p>将放弃当前播放进度</p>',
            onOk: () => {
              this.playControl.currentFrameIndex = 0
              this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
              this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
            },
            onCancel: () => {
            }
          })
        },

        nextFrame () {
          if (this.playControl.currentFrameIndex === this.content.length - 1) {
            this.$Message.error('已无下一条记录')
            return
          }
          this.playControl.currentFrameIndex = this.playControl.currentFrameIndex + 1
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
        },

        nextRunFrame () {
          let length = this.content.length
          for (var i = this.playControl.currentFrameIndex; i < length; i++) {
            if (this.content[i].speed > 0) {
              this.playControl.currentFrameIndex = i
              this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
              this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
              break
            }
          }
        },

        prevFrame () {
          if (this.playControl.currentFrameIndex === 0) {
            this.$Message.error('已无上一条记录')
            return
          }
          this.playControl.currentFrameIndex = this.playControl.currentFrameIndex - 1
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
        },

        prevRunFrame () {
          let length = this.content.length
          for (var i = this.playControl.currentFrameIndex; i >= 0; i--) {
            if (this.content[i].speed > 0) {
              this.playControl.currentFrameIndex = i
              this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
              this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
              break
            }
          }
        },


        // 播放完毕事件
        onTimer () {
          if (this.playControl.currentFrameIndex === this.content.length - 1) {
            if (this.playControl.playIntervalTimer) {
              clearInterval(this.playControl.playIntervalTimer)
              this.playControl.playIntervalTimer = null
            }
            this.$Message.success('播放完毕')
            return
          }
          // this.$refs.bigDataTableRef.setHighlightRow(this.playControl.currentFrameIndex)
          // this.$refs.bigDataTableRef.scrollToRow(this.playControl.currentFrameIndex)
          this.$emit('setHighlightRow', this.playControl.currentFrameIndex)
          this.$emit('scrollToRow', this.playControl.currentFrameIndex)
          this.playControl.currentFrameIndex = this.playControl.currentFrameIndex + 1
          this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
          this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
        },
      },
      mounted() {
      },
      destroyed () {
        if (this.playControl.playIntervalTimer) {
          clearInterval(this.playControl.playIntervalTimer)
          this.playControl.playIntervalTimer = null
        }
      }
    }
</script>

<style scoped>

</style>
